import type { HTMLComponent } from "@commercekit/react";
import { usePrismicLabels } from "~/hooks/usePrismicLabel";

const WvProductActionBar: HTMLComponent<{
  onAddToCart: () => void;
  isLoading?: Boolean;
}> = ({ onAddToCart, isLoading }) => {
  const { $pt } = usePrismicLabels();

  return (
    <button
      type="button"
      disabled={isLoading ? true : false}
      className="btn big"
      data-loading-text="<i className='zmdi-hc-spin' data-icon-after=''></i> <span className='ml-3'>Adding to cart</span>"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onAddToCart();
      }}
    >
      {isLoading ? (
        <>
          <i className="zmdi-hc-spin" data-icon-after=""></i>{" "}
          <span className="ml-3"> {$pt("shopping_cart_action_adding")} </span>{" "}
        </>
      ) : (
        <>
          <span className="mr-2">
            <svg width="25" height="23" xmlns="http://www.w3.org/2000/svg">
              <g fill="#FFF" fillRule="nonzero">
                <path d="M8.53 18.882a1.882 1.882 0 100 3.765 1.882 1.882 0 000-3.765zM21.706 18.882a1.882 1.882 0 100 3.765 1.882 1.882 0 000-3.765zM4.765.059c.45 0 .836.318.923.757l.004.02L8.378 16.06h14.27c.513 0 .93.411.94.922V17a.941.941 0 01-.922.941H7.588a.941.941 0 01-.923-.757l-.004-.02L3.975 1.94H1a.941.941 0 01-.941-.922V1C.059.486.47.069.98.059H4.765z"></path>
                <path d="M23.673 3.864c.636-.205 1.338.338 1.21 1.063l-.005.022-1.694 8.47a.941.941 0 01-.902.757H7.588a.941.941 0 01-.018-1.882h13.92l1.317-6.588H5.706a.941.941 0 01-.941-.923v-.018c0-.514.411-.931.922-.941h17.705c.09 0 .178.012.263.037l.014.004h.004z"></path>
              </g>
            </svg>
          </span>
          <span className="sentence-case inline-block">
            {$pt("shopping_cart_action_add")[0].toUpperCase() +
              $pt("shopping_cart_action_add").slice(1)}
          </span>
        </>
      )}
    </button>
  );
};

export default WvProductActionBar;
